"use client";

import Header from "../../common/Header";
import style from "./helpVideo.module.css";
import { useNavigate } from "react-router-dom";

const HelpVideo = () => {
  const navigate = useNavigate();

  const handleEnded = () => {
    navigate("/");
  };

  return (
    <div className={style.container}>
      <Header header="Help Video" />

      <div className={style.video_container}>
        <video
          className={style.video_style}
          autoPlay
          playsInline
          controls
          onEnded={handleEnded}
        >
          <source
            src="https://s3.ap-southeast-1.amazonaws.com/visaero.assets/videos/T3-VisaLancer.mp4"
            type="video/mp4"
          />
          Your browser does not support the video tag.
        </video>
      </div>
    </div>
  );
};

export default HelpVideo;
